import type { QueryKey, UseQueryResult, UseQueryOptions, QueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { GetLegalDocumentsQueryResponse, GetLegalDocuments404, GetLegalDocuments500 } from "../types/GetLegalDocuments";

export const getLegalDocumentsQueryKey = () =>     [{url:`/api/documents/legal`}] as const;
      export function getLegalDocumentsQueryOptions <TData = GetLegalDocumentsQueryResponse, TError = GetLegalDocuments404 | GetLegalDocuments500>(options: Partial<Parameters<typeof client>[0]> = {}): UseQueryOptions<TData, TError> {
        const queryKey = getLegalDocumentsQueryKey();

        return {
          queryKey,
          queryFn: () => {
            
            return client<TData, TError>({
              method: "get",
              url: `/api/documents/legal`,
              
              
              ...options,
            }).then(res => res.data);
          },
        };
      };
      
/**
 * @summary Запрос на получение публичных документов
 * @link /api/documents/legal
 */

export function useGetLegalDocuments <TData = GetLegalDocumentsQueryResponse, TError = GetLegalDocuments404 | GetLegalDocuments500>(options: {
          query?: UseQueryOptions<TData, TError>,
          client?: Partial<Parameters<typeof client<TData, TError>>[0]>,
        } = {}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const { query: queryOptions, client: clientOptions = {} } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getLegalDocumentsQueryKey();

  const query = useQuery<TData, TError>({
    ...getLegalDocumentsQueryOptions<TData, TError>(clientOptions),
    ...queryOptions
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey as QueryKey;

  return query;
};
